import { type ClientAppConfig, SubscriptionWizardController } from '@ori/subscription-wizard-lib';
import { type FC } from 'react';

// Cutting out optional translations still possibly serialized on the root element.
export const App: FC<ClientAppConfig> = ({ translations, ...configuration }) => (
  <SubscriptionWizardController configuration={configuration} />
);
